export const menuHeader = [
  {
    text: 'studentCampus',
    link: '/campus/myCourses'
  },
  {
    text: 'eduStore',
    link: '/store'
  },
  {
    text: 'teachWithMayahii',
    link: '/createAcademy'
  },
  {
    text: 'administratorsPanel',
    link: 'https://admin.mayahii.com/',
    externalLink: true
  },
  {
    text: 'about',
    link: '/aboutme'
  }
];

export const menuHeaderUDC = [
  {
    text: 'studentCampus',
    link: '/campus/myCourses'
  },
  {
    text: 'eduStore',
    link: '/store'
  }
];
